//import { Autorized } from '../../modules/Auth';

import { useState } from "react";
import AuthProvider from "../../components/Auth/AuthProvider";
import { IAuthUser, ILoginInfo } from "../../components/Auth/types";
import { appAxiosInstance } from "../../api";
import { useNavigate } from "react-router-dom";
import s from "./authScreen.module.css";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { ClothesList } from "../../modules/Clothes";

export default function AuthScreen() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [secondPassword, setSecondPassword] = useState('');

    const navigate = useNavigate();

    const login = async () => {

        const loginInfo: ILoginInfo = {
            email: email,
            password: password
        }

        try {
            const authResponse = await appAxiosInstance.post<IAuthUser>(
                '/mobile/users/login', loginInfo
            );

            const result = authResponse.data;

            if (result) {
                if (result.role === "admin" || result.role === "employee") {
                    localStorage.setItem('token', result.token);
                    if (result.role === "employee") {
                        if (result.permissions.includes("clothes")) {
                            navigate('/');
                        } else if (result.permissions.includes("logs")) {
                            navigate('/logs');
                        } else {
                            const src = '/' + result.permissions[0].toString();
                            navigate(src);
                        }

                    } else {
                        navigate('/')
                    }
                } else {
                    toast.error("Ошибка доступа!");
                    return
                }

            } else {
                console.log("error auth");
            }
        } catch (error) {
            toast.error('Email/пароль неправильные');
        }
    }

    return (
        <div className={s.loginWrapper}>
            <form className={s.loginForm}>
                <h3>Авторизация</h3>
                <div className="mb-3">
                    <label>Ваш e-mail</label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="Введите e-mail"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                </div>
                <div className="mb-3">
                    <label>Пароль</label>
                    <input
                        type="password"
                        className="form-control"
                        value={password}
                        placeholder="Введите пароль"
                        onChange={e => setPassword(e.target.value)}
                    />
                </div>
                <div className="d-grid">
                    <button type="button" className={s.loginBtn} onClick={login}>
                        Войти
                    </button>
                </div>
            </form>
        </div>
    );
}
